<template>
  <div class="opening-cell-renderer">
    <el-button
        size="mini"
        @click="openGenerallLedgerDetailedModal(params)">
      {{formatPrice(params.value ? params.value : 0)}}
    </el-button>
  </div>
</template>

<script>
export default {
  name: "endingBalanceCellRenderer",
  methods: {
    openGenerallLedgerDetailedModal(params) {
      this.params.context.componentParent.openGenerallLedgerDetailedModal(params)
    },
    formatPrice(value) {
      let val = (value/1).toFixed(2).replace(',', '.')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    }
  }
}
</script>

<style lang="less" scoped>
.opening-cell-renderer {
  width:100%;
  padding:0 5px;
  button {
    width: 100%;
    text-align: right;
    display:flex;
    justify-content: flex-end;
  }
}
</style>
